import React from 'react'
import {DatePicker} from "antd"
import moment from "moment"
import PropTypes from "prop-types"

const DateFilter = (props) => {
    const {label, value, name, onChangeDate, showTime, allowClear = false} = props

    const _onChangeDate = (name, value) => {
        if (typeof onChangeDate === 'function') {
            onChangeDate(name, value)
        }
    }

    return (
        <div className="FilterDateFrom">
            <label htmlFor={name}>{label}</label>
            <DatePicker
                id={name}
                name={name}
                allowClear={allowClear}
                defaultValue={moment(value, 'HH:mm DD/MM/YYYY')}
                format="HH:mm DD/MM/YYYY"
                showTime={showTime}
                onChange={(value) => _onChangeDate(name, value)}
            />
        </div>
    )
}

DateFilter.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
    label: PropTypes.string,
    showTime: PropTypes.bool,
    onChangeDate: PropTypes.func.isRequired
}

export default DateFilter